import {
    createSlice,
} from '@reduxjs/toolkit';

import {
    placeBet,
} from '~Betslip/thunks/placeBet';

import {
    closeModal,
    triggerMaxSelectionsModal,
    setFullScreenOff,
} from '~Betslip/actions/uiActions';

import {
    goBackToBetslip,
} from '~Betslip/actions/betReceiptActions';

const initialState = null;

const betReceipt = createSlice({
    name: 'betslip/betReceipt',
    initialState,
    extraReducers: (builder) => {
        builder
        .addCase(goBackToBetslip, () => initialState)
        .addCase(
            placeBet.fulfilled,
            (_state, { payload }) => ({
                ...payload,
                placedFrom: payload.pinnedTab,
            }),
        )
        .addCase(closeModal, () => (initialState))
        .addCase(setFullScreenOff, () => (initialState))
        .addCase(
            triggerMaxSelectionsModal,
            (_state, { payload }) => ({ errno: 'BETSLIP_LIMIT', extraErrorData: payload }),
        );
    },
});

export default betReceipt.reducer;
